/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectTemplatesControllerFindForProjectQueryResponse, ProjectTemplatesControllerFindForProjectPathParams, ProjectTemplatesControllerFindForProjectQueryParams, ProjectTemplatesControllerFindForProject401, ProjectTemplatesControllerFindForProject403 } from "../../models/checklistsController/ProjectTemplatesControllerFindForProject";

function getProjectTemplatesControllerFindForProjectUrl(projectId: ProjectTemplatesControllerFindForProjectPathParams["projectId"]) {
  const res = { method: 'GET', url: `/api/v1/project-templates/${projectId}` as const }  
  return res
}

/**
 * @description Returns checklist templates tagged as project-level that are available for the given project. Includes templates scoped to the project's parent team and organization, plus global project-level templates. Respects activation status.
 * @summary Get project-level templates available for a project
 * {@link /api/v1/project-templates/:projectId}
 */
export async function projectTemplatesControllerFindForProject(projectId: ProjectTemplatesControllerFindForProjectPathParams["projectId"], params?: ProjectTemplatesControllerFindForProjectQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ProjectTemplatesControllerFindForProjectQueryResponse, ResponseErrorConfig<ProjectTemplatesControllerFindForProject401 | ProjectTemplatesControllerFindForProject403>, unknown>({ method : "GET", url : getProjectTemplatesControllerFindForProjectUrl(projectId).url.toString(), params, ... requestConfig })  
  return res.data
}